import { WeekPicker } from "@features/dga/components/weekPicker/WeekPicker";
import { WeekRange } from "@features/dga/components/weekPicker/types";
import { Trans } from "@lingui/macro";
import { Box, Typography, Button } from "@mui/material";
import { Dayjs } from "dayjs";

interface Props {
  selectedDate: Dayjs;
  onPrevious: () => void;
  onNext: () => void;
  onDateChange: (range: WeekRange) => void;
  disableNext: boolean;
}

export function WeekSelector({
  selectedDate,
  onPrevious,
  onNext,
  onDateChange,
  disableNext
}: Props) {
  const getWeekRangeText = (date: Dayjs) => {
    const startOfWeek = date.weekday(0);
    const endOfWeek = date.weekday(6);
    return `${startOfWeek.format('DD/MM/YYYY')} - ${endOfWeek.format('DD/MM/YYYY')}`;
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
    <Typography>{'Emisión de reportes del periodo'} {getWeekRangeText(selectedDate)}</Typography>
      <Button
        variant="contained"
        onClick={onPrevious}
      >
        <Trans>Semana Anterior</Trans>
      </Button>
      <Button
        variant="contained"
        disabled={disableNext}
        onClick={onNext}
      >
        <Trans>Próxima Semana</Trans>
      </Button>
      <WeekPicker
        onChange={onDateChange}
        value={selectedDate}
      />
    </Box>
    
  );
}